<template>
  <el-dialog
    title="固定签署方"
    :visible.sync="regularVisi"
    :close-on-click-modal="false"
    width="30%"
    @close="closePup"
  >
    <p>添加固定签署方</p>
    <!-- list -->
    <div class="list-box">
      <el-card
        shadow="hover"
        v-for="item of regularList"
        :key="item.emailOrMobile"
        class="list-card"
        :class="haveChecked(item) ? 'tpl-active' : ''"
        @click.native="tabItemActive(item)"
        @dblclick.native="dbActive(item)"
      >
        <div class="tpl-box">
          <p class="item-info">
            <img
              :src="item.userType === 0 ? personIcon : enteIcon"
              alt=""
              style="margin-right:10px"
            />
            <span>
              <p>{{ item.name }}</p>
              <p>{{ item.emailOrMobile }}</p>
            </span>
          </p>
        </div>
      </el-card>
      <el-empty
        description="暂无数据"
        v-show="regularList.length === 0"
      ></el-empty>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closePup" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="tplConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: { regularVisi: Boolean, regularList: Array },
  data() {
    // 这里存放数据
    return {
      regularCheck: [], // 选择的固定签署方
      enteIcon: require("../../../static/images/icon/enter.png"),
      personIcon: require("../../../static/images/icon/person.png")
    };
  },
  // 方法集合
  methods: {
    // 关闭弹窗
    closePup() {
      this.$emit("update:regularVisi", false);
    },
    haveChecked(item) {
      return this.regularCheck.some(
        V => item.emailOrMobile === V.emailOrMobile
      );
    },
    async tplConfirm() {
      this.$emit("regularAdd", this.regularCheck);
      this.closePup();
    },
    // 选择tabitem
    tabItemActive(regular) {
      const checked = this.haveChecked(regular);
      if (checked) {
        this.regularCheck.forEach((item, i) => {
          if (item.emailOrMobile === regular.emailOrMobile) {
            this.regularCheck.splice(i, 1);
          }
        });
      } else {
        this.regularCheck.push(regular);
      }
    },
    // 快速选择
    async dbActive(item) {
      await this.tabItemActive(item);
      await this.tplConfirm();
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<style lang="less" scoped>
.list-box {
  min-height: 10vh;
  max-height: 51vh;
  margin: 10px 0;
  overflow-y: auto;
  .list-card {
    margin-bottom: 4px;
    cursor: pointer;
    &:hover {
      background-color: #ebeef5;
    }
    .tpl-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .item-info {
        display: flex;
        align-items: center;
        > img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
.tpl-active {
  background-color: #ebeef5;
  border: 1px solid #ec1c1c;
}
</style>



// WEBPACK FOOTER //
// pages/initiation/components/regularPup.vue